










































import { Component, Vue} from 'vue-property-decorator'
import firebase from 'firebase/app'
import db from '@/firebase/firebaseConfig'
@Component({
  name: 'Comment'
})
export default class Comment extends Vue {
  
  isLoading: boolean = false 
  newMessage: string = ''
  messages: any[] = []

  mounted() {
    this.getItems()
  }

  async getItems() {
    console.log('getItems')
    this.isLoading = true
    await this.readFirestore()
    this.isLoading = false
  }

  async readFirestore() {
    try {
      this.messages = []
      const items: firebase.firestore.QuerySnapshot = await db.collection('ideas').doc(this.$route.params.id).collection('messages').get()
      items.docs.forEach((item: firebase.firestore.QueryDocumentSnapshot) => {
        let message = {
          id: item.id,
          content: item.data().content
        }
        this.messages.push(message)
      })
      console.log(this.messages)
    } catch (error) {
      console.error('firebase error', error)
    }
  }

  addMessage() {
    if(this.newMessage){
      db.collection('ideas').doc(this.$route.params.id).collection('messages').add({
        content: this.newMessage,
      }).catch(err => {
        console.log(err)
      })
      this.newMessage = ''
    }
  }

}
